import React from 'react';
import { Box, Card, CardHeader, CardContent, Typography, Divider, Chip, Grid } from '@mui/material';
import { variants } from '../../../../variants/variants';
import {
  Approval,
  DateRange,
  Description,
  GppMaybe,
  Groups3,
  Info,
  LunchDining,
  Notes,
  Pages,
  Pending,
  Person3,
  Verified,
  Warning,
} from '@mui/icons-material';
import { capitalizeFirstLetter } from '../../../../utils/capitalizeFirstLetter';

const RequestDialog = ({ selectedRequest, isAdmin, isHr }) => {
  return (
    <Box sx={{ width: '100%' }}>
      {/* <Card sx={{ marginBottom: 2.5, marginTop:2.5 }}> */}

      <Box display="flex" alignItems="start" mb={2} mt={2}>
        {selectedRequest?.adminStatus === 'Approved' && (
          <>
            <Verified sx={{ marginRight: '8px', color: 'green' }} />
            <Typography color="green">Request is {selectedRequest.adminStatus}!</Typography>
          </>
        )}

        {selectedRequest?.adminStatus === 'Pending' && (
          <>
            <GppMaybe sx={{ marginRight: '8px', color: 'orange' }} />
            <Typography variant="body1" color="orange">
              Request is pending!
            </Typography>
          </>
        )}
        {selectedRequest?.adminStatus === 'Rejected' && (
          <Grid>
            <Grid sx={{ display: 'flex' }}>
              <Warning sx={{ marginRight: '8px', color: 'red' }} />
              <Typography color="red">Request is {selectedRequest.adminStatus}!</Typography>
            </Grid>
            <Divider sx={{ margin: '10px 0' }} />
            <Typography>
              <b>Reason for Reject : </b>
              {selectedRequest.adminRejectionReason}
            </Typography>
          </Grid>
        )}
      </Box>
      <Divider sx={{ mb: 2 }} />
      {selectedRequest?.hrStatus === 'Rejected' && (
        <>
          <Box display="flex" alignItems="start" mb={2}>
            <Typography>
              <b>Reason for Rejected By HR : </b>
              {selectedRequest.hrRejectionReason}
            </Typography>
          </Box>
          <Divider sx={{ mb: 2 }} />
        </>
      )}
      <Box display="flex" alignItems="start" mb={2}>
        <Typography>
          <b>Applied on </b> {new Date(selectedRequest.dateRequested).toLocaleDateString()}
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />

      <Box display="flex" alignItems="start" mb={2}>
        <LunchDining sx={{ marginRight: '8px', color: 'grey' }} />
        <Typography>Request for : {selectedRequest.requestType}</Typography>
      </Box>

      {isAdmin || isHr ? <Typography sx={{ mb: 2 }}>Requested By : {selectedRequest.requestedBy}</Typography> : <></>}
      <Divider sx={{ mb: 2 }} />

      <Box display="flex" alignItems="start" mb={2}>
        <DateRange sx={{ marginRight: '8px', color: 'grey' }} />
        <Typography sx={{ alignItems: 'center' }}>
          Date for {selectedRequest.requestType} : {new Date(selectedRequest.requestDate).toLocaleDateString()}
        </Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />
      <Box display="flex" alignItems="start" mb={2}>
        <Description sx={{ marginRight: '8px', color: 'grey' }} />{' '}
        <Typography>Reason : {selectedRequest.otherDetails}</Typography>
      </Box>

      <Divider sx={{ mb: 2 }} />
      <Box display="flex" alignItems="start" mb={2}>
        <Groups3 sx={{ marginRight: '8px', color: 'grey' }} />
        <Typography>Number of Members : {selectedRequest.numberOfMembers}</Typography>
      </Box>
      <Typography>
        {selectedRequest.personName?.map((name, index) => (
          <Chip
            key={index}
            label={capitalizeFirstLetter(name)}
            sx={{
              marginRight: '8px',
              marginBottom: '10px',
              cursor: 'default',
              '&:hover': { backgroundColor: '#e0e0e0' },
            }}
          >
            {index + 1}. {name}
          </Chip>
        ))}
      </Typography>

      {/* </Card> */}
    </Box>
  );
};

export default RequestDialog;
